import { Translation } from '@jsverse/transloco';
import { VAR_NATIONAL_ID_LENGTH } from '../../../../shared/config/consts';

const en = {
  citizen: {
    loginToContinue: 'Login to Continue',

  },
  location: {
    province: 'Province',
    district: 'District',
    sector: 'Sector',
    cell: 'Cell',
    village: 'Village',
  },
  form: {
    title: {
      addCategory: 'Ongeraho icyiciro',
      editCategory: 'Hindura icyiciro',
      addAccount: 'Umukozi mushya',
      editAccount: 'Hindura umukozi',
      addInstitution: 'Ikigo gishya',
      editInstitution: 'Hindura ikigo',
      newCase: 'Ikibazo gishya',
      editCase: 'Hindura ikibazo',
      newAnnouncement: 'Itangazo rishya',
      editAnnouncement: 'Hindura itangazo',
      newCitizen: 'Umuturage mushya',
      editCitizen: 'Hindura umuturage',
      anonymousComplaint: "Ikibazo cy'ibanga",
      orientationLevel: 'Orientation Level',
    },
    label: {
      firstName: 'First Name',
      middleName: 'Middle Name',
      lastName: 'Last Name',
      documentType: 'Document',
      documentNumber: 'Document Number',
      name: 'Name',
      phoneNumber: 'Phone Number',
      gender: 'Gender',
      email: 'Email',
      nationalId: 'National ID',
      province: 'Province',
      district: 'District',
      sector: 'Sector',
      cell: 'Cell',
      village: 'Village',
      title: 'Title',
      password: 'Password',
      description: 'Description',
      caseType: 'Case type',
      severity: 'Severity',
      victimsNumber: 'Number of victims',
      trackingLevel: 'Level',
      estimateDays: 'Estimated days',
      primaryOrganization: 'Primary Org',
      informedOrganization: 'Informed organizations',
      issueLocation: 'Location details',
      issueDetails: 'Details',
      orientationLevel: 'Case tracking level',
      recordingLevel: 'Recording Level',
      search: 'Search',
      goodGovernanceSection: 'Good Governance Section',
      complaint: 'Complaint',
      rejectionReason: 'Rejection Reason',
      optional: '(Optional)',
    },
    placeholder: {
      documentType: 'Enter Document Type',
      documentNumber: 'Enter Document Number',
      name: 'Enter name',
      phoneNumber: 'Enter phone number',
      gender: 'Select gender',
      email: 'Enter email',
      nationalId: 'Enter national ID',
      province: 'Select Province',
      district: 'Select district',
      sector: 'Select sector',
      cell: 'Select cell',
      village: 'Select village',
      password: 'Enter Password',
      description: 'Enter description',
      title: 'Enter Title',
      complaint: 'Enter complaint',
      caseType: 'Select case type',
      severity: 'Select severity level',
      victimsNumber: 'Select number of victims',
      trackingLevel: 'Select tracking level',
      estimateDays: 'Enter estimated days',
      primaryOrganization: 'Select primary organization',
      informedOrganization: 'Select informed organizations',
      issueLocation: 'Enter issue location details',
      issueDetails: 'Enter issue details',
      orientationLevel: 'Select case tracking level',
      recordingLevel: 'Select recording level',
      searchInstitution: 'Search here',
      firstName: 'Enter first name',
      lastName: 'Enter last name',
    },
    button: {
      forgotPassword: 'Forgot Password?',
      login: 'Login',
      resetPassword: 'Reset Password',
      alreadyHaveAnAccount: 'Already have an account?',
      submitButton: 'Submit',
      signUp: 'Sign up',
      ok: 'Okay',
      cancel: 'Cancel',
      addCategory: 'Add Category',
      addAccount: 'Add Account',
      addInstitution: 'Add Institution',
      newCase: 'New Case',
      newAnnouncement: 'New Announcement',
      newCitizen: 'New Citizen',
      casesStatus: {
        closed: 'Closed',
        ongoing: 'Ongoing',
        done: 'Resolved',
        reopened: 'Re-opened',
      },
    },
    options: {
      severity: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
      },
      trackingLevel: {
        district: 'District',
        sector: 'Sector',
        cell: 'Cell',
        village: 'Village',
      },
      victimsNumber: {
        one: 'One',
        multiple: 'Multiple',
      },
    },
    errors:{
      emailPhoneRequired:'Email or Phone is Required',
      invalidEmailOrPhoneNumber:"Invalid Email or Phone number (07 XXXX XXXX)",
      passwordRequired:"Password is required",
      firstIsRequired:"First name is required",
      lastIsRequired:"Last name is required",
      genderIsRequired:"Gender is required",
      nidIsRequired:`National Id must be ${VAR_NATIONAL_ID_LENGTH} Digits`,
      phoneIsRequired:"Phone Number (07 XXXX XXXX) is required",
      codeRequired: "Verification code is required",
    }
  },
  resetPasswordForm: {
    title: 'Reset Your Password',
    description: 'Set a new password to continue and access the platform',
    label: {
      code: 'Old Password',
      newPassword: 'New Password',
    },
    placeholder: {
      code: 'Enter Old Password',
      enterNewPassword: 'Enter New Password',
    },
    button: 'Change To New Password',
  },

  casesStatus: {
    closed: 'Closed',
    ongoing: 'Ongoing',
    done: 'Resolved',
    reopened: 'Re-Opened',
    pending: 'Pending',
  },
  announcementStatus: {
    published: 'Ryatangarijwe',
    unpublished: 'Ryarangiye',
  },
  noCasesFound: 'No cases found',
  fetchingData: "Fetching data...",
  editPersonalInfo: "Personal Info",
  editPersonalInfoDescription: "Personal information are being retrieved from your NID and cannot be edited",
  changePassword: " Change Password",
  changePasswordDescription: "Enter your current password to change your password",
  currentPassword: "Current Password",
  confirmPassword: "Confirm Password",
  enterConfirmPassword: "Enter Confirm Password",
  enterCurrentPassword: "Enter Current Password",

  // MENU
  dashboard: 'Dashboard',
  complaints: 'Complaints',
  announcements: 'Announcements',
  tipOffs: 'TipOffs',
  manage: 'Manage',
  citizens: 'Citizens',
  institutions: 'Institutions',
  accounts: 'Accounts',
  security: 'Security',
  overview: 'Overview',
  cases: 'Cases',
  analytics: 'Analytics',
  staff: 'Staff',
  rolesAndPermissions: 'Roles & Permissions',
  systemSettings: 'System Settings',
  tipOffCategories: 'TipOff Categories ',

  tipOffCategoryPage: {
    title: 'TipOff Categories',
    description: 'Manage tip-off categories',
    action: {
      addNewCategory: 'Add Category',
    },
  },
  modal: {
    title: 'Filter',
    byInstitution: 'By Institution',
    clear: 'Clear Filters',
    apply: 'Apply Filters',
    edit: 'Edit ',
    view: 'View ',
    deactivate: 'Deactivate',
    delete: 'Delete',
  },
  noDocumentsFound: "No Document Found",
  quickOverview: 'Quick Overview',
  landingPageTitle: 'Welcome to',
  reportAnonymously: 'Report anonymously',
  home: 'Home',
  tipOffCategory: 'Category',
  tipOffCategoryPlaceholder: 'Select a tip-off category',
  myDashboard: 'My Dashboard',
  announcement: 'Announcements',
  newAnonymousComplaint: 'Report Anonymously',
  issueDescription: 'Issue Description',
  enterIssueDescription: 'Enter issue description',
  issueTitlePlaceholder: 'Enter issue title',
  welcome: 'Welcome',
  submitComplaint: 'Submit Complaint',
  submitComplaintDescription: 'Requires an account to submit a complaint.',
  submitComplaintButton: 'Submit a Complaint',
  anonymousComplaintDescription: 'No personal information required to submit.',
  anonymousComplaintNoticeTitle: "Notice",
  anonymousComplaintNoticeMessage: "Submitted tip-offs are reviewed and handled internally by the responsible institution. As a citizen, you should not expect follow-up or direct contact from the Mbaza team. If you would like a response or to be contacted, please submit a regular complaint instead.",
  newComplaint: 'New Complaint',
  closed: 'Closed',
  ongoing: 'Ongoing',
  nationalId: 'National ID',
  name: 'Name',
  phoneNumber: 'Phone Number',
  gender: 'Gender',
  email: 'Email',
  complaintsAndCases: 'Complaints & Cases',
  searchHere: 'Search here',
  underReview: 'Under review / Rejected',
  myComplaints: 'My Complaints',
  statusOngoing: 'Ongoing',
  statusPending: 'Pending',
  statusReOpened: 'Re-opened',
  statusClosed: 'Closed',
  statusDone: 'Resolved',
  statusRejected: 'Rejected',
  issueLocation: 'Issue Location',
  district: 'District',
  sector: 'Sector',
  cell: 'Cell',
  village: 'Village',
  selectDistrict: 'Select District',
  selectSector: 'Select Sector',
  selectCell: 'Select Cell',
  selectVillage: 'Select Village',
  issueDetails: 'Issue Details',
  title: 'Title',
  enterTitle: 'Enter title',
  complaint: 'Complaint',
  complaintTitle: 'Complaint Title',
  typeYourComplaint: 'Type your complaint',
  download: 'Download',
  noFilesAttached: 'No Files Attached',
  complaintDetails: 'Complaint Details',
  reportedOn: 'Reported on',
  close: 'Close',
  loading: 'Loading...',
  supportingAttachments: 'Supporting Attachments',
  caseDetails: 'Case Details',
  reportedBy: 'Reported by',
  informedInstitutions: 'Informed Institutions',
  noOrganizationsInformed: 'No organizations informed yet',
  caseTimeline: 'Case Timeline',
  trackingLevel: 'Recording Level',
  tracking: 'Tracking ',
  trackingPlaceholder: 'Enter tracking number',
  createdBy: 'Created By',
  assignedTo: 'Assigned To',
  primaryOrganization: 'Primary Organization',
  none: 'None',
  myProfile: 'My Profile',
  profile: 'Profile',
  logout: 'Logout',
  login: 'Login',
  trackComplaint: 'Track Complaint',
  trackAnotherComplaint: 'Track Another Complaint',
  reportedAComplaint: 'Reported a Complaint',
  createdACase: 'Created a Case',
  addedAComment: 'Added a Comment',
  trackYourComplaint: 'Track Your Complaint',
  mostCasePerDistrict: 'Most cases per District',
  mostCasePerChannel: 'Most cases per Channel',
  mostCasePerInstitution: 'Most cases per Institutions',
  mostCasePerCategory: 'Most cases per Category',
  caseTrendThisYear: 'Case Trend This Year',
  notifications: 'Notifications',
  newCase: 'New Case',
  createCase: 'Create Case',
  nonOrientedComplaints: 'Non-oriented Complaints',
  filterComplaints: 'Filter Complaints',
  today: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  thisYear: 'This Year',
  allTime: 'All Time',
  enterNamesKeyword: 'Enter names, keyword, etc...',
  retry: 'Retry',
  urgentCases: 'Urgent Cases',
  nothingToShow: 'Nothing to show',
  thisListIsEmpty: 'This list is Empty',
  filter: 'Filter',
  allCases: 'All Cases',
  selectStatus: 'Select Status',
  selectCategory: 'Select Category',
  selectOwnership: 'Select Ownership',
  primaryCases: 'Primary Cases',
  secondaryCases: 'Secondary Cases',
  status: 'Status',
  type: 'Type',
  filterCases: 'Filter Cases',
  byLocation: 'By Location',
  byInstitutions: 'By Institutions',
  bySeverityAndUrgency: 'By Urgency',
  institution: 'Institution',
  severity: 'Severity',
  urgency: 'Urgency',
  ownership: 'Ownership',
  allStatus: 'All Status',
  allTypes: 'All Types',
  allOwnerships: 'All Ownerships',
  allDistricts: 'All Districts',
  allSectors: 'All Sectors',
  allCells: 'All Cells',
  allVillages: 'All Villages',
  allInstitutions: 'All Institutions',
  allSeverities: 'All Severities',
  allUrgencies: 'All Urgencies',
  clearFilters: 'Clear Filters',
  filterList: 'Filter List',
  dateRange: 'Date Range',
  period: 'Period',
  selectHere: 'Select here',
  mostCasesPerCategory: 'Most cases per Category',
  mostCasesPerInstitutions: 'Most cases per Institutions',
  mostCasesPerDistrict: 'Most cases per District',
  noDataAvailable: 'No data available',
  totalCases: 'Total Cases',
  new: 'New',
  reopened: 'Re-Opened',
  avgReactionTime: 'Avg Reaction Time',
  avgSatisfaction: 'Avg Satisfaction',
  done: 'Resolved',
  casesOverview: 'Cases Overview',
  casesTrendPerYear: 'Cases trend per year',
  casesOnTheMap: 'Cases on the Map',
  totalCitizens: 'Total Citizens',
  withOngoingCases: 'With ongoing cases',
  avgCasesPerUser: 'Avg cases per user',
  avgCasesPerInstitution: 'Avg cases per Institution',
  female: 'Female',
  male: 'Male',
  foreigners: 'Foreigners',
  newCitizen: 'New Citizen',
  createCitizen: 'Create Citizen',
  saveChanges: 'Save Changes',
  editCitizen: 'Edit Citizen',
  numberOfCases: 'Number of cases',
  totalInstitutions: 'Total Institutions',
  institutionsWithOngoingCases: 'Institutions with ongoing cases',
  newInstitution: 'New Institution',
  addInstitution: 'Add Institution',
  ongoingCases: 'Ongoing cases',
  joined: 'Joined',
  myCases: 'My Cases',
  taggedCases: 'Tagged Cases',
  organizationDetails: 'Organization Details',
  performance: 'Performance',
  admin: 'Admin',
  addStaff: 'Add Staff',
  newStaff: 'New Staff',
  systemAccounts: 'System Accounts',
  role: 'Role',
  lastLogin: 'Last Login',
  edit: 'Edit',
  addAccount: 'Add Account',
  addRole: 'Add Role',
  usedBy: 'Used by',
  roles: 'Roles',
  newRole: 'New Role',
  newAnnouncement: 'New Announcement',
  unpublish: 'Unpublish',
  expiresAt: 'Expires At',
  announcementTitle: 'Announcement Title',
  announcementValidity: 'Announcement Validity',
  expiryDate: 'Expiry Date',
  publishAnnouncement: 'Publish Announcement',
  yourAnnouncement: 'Your Announcement',
  announcementValidityDescription:
    'This is the period where the announcement will be active, if not set it\'s set to 5 days from the published date',
  published: 'Published',
  unpublished: 'Expired',
  reviewComplaint: 'Review Complaint',
  rating: 'Rating',
  commentsOptional: 'Comments (Optional)',
  shareYourFeedback: 'Share your feedback...',
  reporterReview: "Reporter's Review",
  register: 'Register',
  enterNationalId: 'Enter National ID',
  continue: 'Continue',
  haveAnAccount: 'Have an account?',
  selectYourPhoneNumber: 'Select your phone number',
  associatedPhoneNumbers: 'Associated phone numbers',
  requestVerificationCode: 'Request verification code',
  verificationCode: 'Verification code',
  verificationCodeDescription:
    'You have received a verification code on your phone {{ phone }}',
  verifyCode: 'Verify code',
  completeYourRegistration: 'Complete your Registration',
  completeRegistrationDescription:
    'Please provide the following information to complete your registration',
  firstName: 'First name',
  lastName: 'Last name',
  enterEmail: 'Enter email',
  password: 'Password',
  enterPassword: 'Enter password',
  signUp: 'Sign up',
  emailOrPhone: 'Email / Phone',
  enterEmailOrPhoneNumber: 'Enter Email or Phone Number',
  forgotPassword: 'Forgot Password?',
  resetPassword: 'Reset Password',
  goToLogin: 'Go to Login',
  code: 'Code',
  enterCode: 'Enter Code',
  enterNewPassword: 'Enter New Password',
  newPassword: 'New Password',
  confirmPasswordReset: 'Confirm Password Reset',
  complaintType: 'Complaint Type',
  noNotificationsFound: 'No notifications found',
  selectInstitution: 'Select Institution',
  manageCaseCategoriesDescription:
    'Manage the available case categories and their descriptions.',
  caseCategories: 'Case Categories',
  addCaseCategory: 'Add Case Category',
  updateCaseCategory: 'Update Case Category',
  deleteCaseCategory: 'Delete Case Category',
  caseCategoryName: 'Case Category Name',
  caseCategoryDescription: 'Case Category Description',
  enterCaseCategoryName: 'Enter Case Category Name',
  enterCaseCategoryDescription: 'Enter Case Category Description',
  editAnnouncement: 'Edit Announcement',
  tipoffs: 'Tipoffs',
  institutionCases: 'Institution Cases',
  permissions: 'Permissions',
  caseCategoriesSettings: 'Case Categories Settings',
  createdAt: 'Created At',
  description: 'Description',
  refreshAnalytics: 'Refresh Analytics',
  analyticsRefreshed: 'Analytics refreshed successfully',
  errorRefreshingAnalytics: 'Error refreshing analytics',
  organization: 'Organization',
  occupation: 'Occupation',
  private: 'Private',
  noTimestamp: 'No timestamp',
  theCaseWasMarkedAs: 'The case was marked as',
  theCaseWasEscalatedTo: 'The case was escalated to',
  escalatedTheCaseTo: 'escalated the case to',
  systemConfiguration:{
    title:'How would you like to receive notification',
    description:' Edit notification preferences',
    label:'System Configuration',
  },
  verifyComplaint:"Verify Complaint",
  verify:'Verify',
  verifyUser:"Verify User",
  verifyUserDescription:"We've sent a verification code to your phone",
  provinceIsRequired: "Province is required",
  districtIsRequired: "District is required",
  sectorIsRequired: "Sector is required",
  cellIsRequired: "Cell is required",
  villageIsRequired: "Village is required",
  titleIsRequired: "Title is required",
  titleMaxLength: "Title must be at most 250 characters",
  complaintIsRequired: "Complaint description is required",
  tipOffCategoryIsRequired: "Tip-off category is required",
  caseNotFound: 'Complaint received and is under review',
  goToHome: 'Go to Home',
  trackComplaintNumber: 'Track Complaint #',
  noComplaintCode: 'No complaint code provided',
  verificationCodeSentTo: 'Verification code sent to',
  success: "Success",
  toast:{
    error:"Error",
    success:"Success",
    clipboard:'Application number copied to clipboard'
  },
  menu: "Menu",
} satisfies Translation;

export default en;
